import React, { FunctionComponent } from "react";
import ExperimentAndInnovationInfo from "../../../common/components/project-classification-contents/experiment-innovation-info";

const ExperimentAndInnovationToolTipInfo: FunctionComponent = () => (
  <div className="tooltip-content">
    <ExperimentAndInnovationInfo />
  </div>
);

export default ExperimentAndInnovationToolTipInfo;
